import { DrillType } from '@drills/infra';

export const drillTypeLabelMapper = (type: DrillType): string => {
  switch (type) {
    case DrillType.Dry:
      return 'Dry';
    case DrillType.Live:
      return 'Live';
  }
};
